export const INACTIVE_FILL = 'rgba(255, 255, 255, 0.2)';

export const getDefaultFeatureStyle = (theme, color = 'primary') => ({
  'stroke-color': `${theme.palette[color].main}`,
  'stroke-width': 3,
  'fill-color': `${theme.palette[color].light}66`,
});

export const getSelectedStyle = (theme, color = 'primary') => [
  {
    'stroke-color': 'white',
    'stroke-width': 4,
    'fill-color': `${theme.palette[color].main}b8`,
  },
  {
    'stroke-color': '#191919',
    'stroke-width': 2,
  },
];

export const getBasicStyle = () => [
  {
    'stroke-color': 'white',
    'stroke-width': 4,
    'fill-color': INACTIVE_FILL,
  },
  {
    'stroke-color': '#191919',
    'stroke-width': 2,
  },
];

export const getHoverStyle = theme => [
  {
    'stroke-color': '#00000055',
    'stroke-width': 4.5,
    'fill-color': `${theme.palette.primary.main}11`,
  },
  {
    'stroke-color': theme.palette.primary.main,
    'stroke-width': 2.5,
  },
];
